import { Expose } from 'class-transformer'
import { MediaLibraryFolder } from '../../entity'

export class GetMediaLibraryFolderDTO {

    @Expose()
    mediaLibraryFolder!: MediaLibraryFolder

}
